<script setup lang="ts">
import { locale } from '../../locale';
import { finishState } from '../../states/finishState';
import { cleanup } from '../../states/media/state';
import { transitionEvents } from '../../states/transitions';
import { ws_instance } from '../../websocket/ws-instance';
import { clearHandUpState } from '../../states/handUpState';
import { clearAllNotifications } from '../../states/notifications';
import CompletedRoom from './CompletedRoom.vue';
import YouKickRoom from './YouKickRoom.vue';
import YouLeaveRoom from './YouLeaveRoom.vue';
clearHandUpState()
clearAllNotifications()
transitionEvents.emit('finish')
ws_instance.disconnect()
cleanup()
</script>
<template>
  <CompletedRoom v-if="finishState.reason === 'complete' || finishState.reason === 'tarifftime'" :reason="finishState.reason" />
  <YouKickRoom v-else-if="finishState.reason === 'kick'" :reason-text="locale.endPage.kickedDescription" />
  <YouLeaveRoom v-else-if="finishState.reason === 'leave'" />
  <YouKickRoom v-else-if="finishState.reason === 'new-auth'" :reason-text="locale.endPage.newAuthExitDescription" />
  <YouKickRoom v-else-if="finishState.reason === 'network'" :reason-text="locale.endPage.networkError" />
  <YouKickRoom v-else-if="finishState.reason === 'first-connect'" :reason-text="locale.endPage.firstConnectDescription"/>
  <YouKickRoom v-else-if="finishState.reason === 'rejected'" :reason-text="locale.endPage.rejectedDescription"/>
  <YouKickRoom v-else-if="finishState.reason === 'expired'" :reason-text="locale.endPage.expiredDescription"/>
</template>
<style scoped>
  
</style>
